import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useBlocker } from '@tanstack/react-router';
import verificationFailedIcon from '@Assets/icons/verification-failed.svg';

export const VerificationFailed = () => {
  const { t } = useTranslation();

  useBlocker({
    shouldBlockFn: () => {
      return true;
    },
    enableBeforeUnload: false,
  });

  return (
    <div className='flex min-h-full w-full items-center justify-center bg-surface-primary-bw-03 p-[40px] tablet:px-[16px]'>
      <div className='flex w-full max-w-[468px] h-[360px] flex-col items-center rounded-[12px] bg-surface-primary-bw-00 px-[32px] py-[40px] tablet:max-w-[468px]'>
        <div className='flex flex-col items-center gap-[42px]'>
          <div className='flex flex-col items-center gap-[32px]'>
            <img
              src={verificationFailedIcon}
              alt={t('pages.uboOnboarding.verificationFailed.iconAlt')}
              className='h-[76px] w-[76px]'
            />

            <div className='flex flex-col gap-[16px] text-center'>
              <Heading.H4 id='verification-failed-title' fontWeight={FontWeight.SEMIBOLD}>
                {t('pages.uboOnboarding.verificationFailed.title')}
              </Heading.H4>

              <Text.H9 id='verification-failed-content' className='text-text-main-secondary'>
                {t('pages.uboOnboarding.verificationFailed.bodyContent')}
              </Text.H9>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
